import { render, staticRenderFns } from "./UserManagement.vue?vue&type=template&id=37db4e62&scoped=true"
import script from "./UserManagement.vue?vue&type=script&lang=js"
export * from "./UserManagement.vue?vue&type=script&lang=js"
import style0 from "./UserManagement.vue?vue&type=style&index=0&id=37db4e62&scoped=true&lang=css"
import style1 from "./UserManagement.vue?vue&type=style&index=1&id=37db4e62&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37db4e62",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/pagsmile/front-end/pagsmile-dashboard/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('37db4e62')) {
      api.createRecord('37db4e62', component.options)
    } else {
      api.reload('37db4e62', component.options)
    }
    module.hot.accept("./UserManagement.vue?vue&type=template&id=37db4e62&scoped=true", function () {
      api.rerender('37db4e62', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/UserManagement/UserManagement.vue"
export default component.exports